import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { GoogleTagManagerService } from 'app/_services/google-tag-manager.service';

declare let $: any;

@Component({
  selector: 'snc-notification-bell',
  templateUrl: './snc-notification-bell.component.html',
  styleUrls: ['./snc-notification-bell.component.css', '../../../../assets/css/senac.css']
})
export class SncNotificationBellComponent implements OnInit {

  @Input("s-modulo-id") moduloId: string;
  @Input("s-url-comunicacao") urlComunicacao: string;
  @Input("s-novidades") novidades: Array<any>;
  @Output("s-novidades-lida") novidadesLida = new EventEmitter<any>();
  novidadeCompleta: any;
  exibirNovidadeCompleta = false;
  novidadesNaoLida: number = 0;
  
  constructor(private gtmService: GoogleTagManagerService) { }

  ngOnInit() {
    $(document).on('click', '.dropdown-menu', function (e) {
      e.stopPropagation();
    });

    this.initializeDropdown();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.calcularNovidadesNaoLida();
  }

  initializeDropdown() {
    $('.dropdown-toggle').dropdown();
  }

  calcularNovidadesNaoLida() {
    if(this.novidades && this.novidades.length > 0) {
      this.novidadesNaoLida = 0;
      this.novidades.forEach((novidade) => {
        if(!novidade.lida)
          this.novidadesNaoLida += 1;
      });
    }
  }

  exibirNovidade(novidade: any) {
    this.exibirNovidadeCompleta = true;
    this.novidadeCompleta = novidade;
  }

  listarNovidades() {
    this.exibirNovidadeCompleta = false;
  }

  lerNovidades() {
    this.novidadesNaoLida = 0;
    let novidades = [];
    novidades = this.getNovidadesNaoLidas();
    if(novidades && novidades.length > 0)
      this.novidadesLida.emit(novidades);
    this.sendEventGtm('CliqueNovidades', 'ComponentNovidades');
  }

  navegarComunicacao(){
    localStorage.setItem('filtrar-modulo-novidade', this.moduloId);
    window.open(this.urlComunicacao);
  }

  getNovidadesNaoLidas() {
    return this.novidades.filter((novidade) => {
      return novidade.lida == false;
    })
    .map((novidade) => {
      return novidade.id;
    });
  }

  public sendEventGtm(event: string, origem: string) {
    const gtmTag = {
      event: event,
      origem: origem,
    };

    this.gtmService.pushTag(gtmTag);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom/snc-notification-bell/snc-notification-bell.component.ts